import { useSWRConfig } from "swr";
import useSWRMutation from "swr/mutation";
import type { SWRMutationResponse } from "swr/mutation";
import { HTTP_METHODS } from "rivals/services/base";
import { KEY as MUTATE_KEY } from "rivals/services/getCurrentUser/useGetCurrentUser";
import getFetchHeaders from "rivals/shared/utils/getFetchHeaders";

const KEY = "/api/v2/users/alerts/mark_all_read";

export default function useMarkAllUserAlertsRead(
  callback?: () => void
): SWRMutationResponse {
  const { mutate } = useSWRConfig();

  return useSWRMutation(
    KEY,
    async function (url) {
      await fetch(url, {
        headers: getFetchHeaders(),
        method: HTTP_METHODS.PUT
      });
    },
    {
      onSuccess: function () {
        mutate(MUTATE_KEY);
        callback && callback();
      }
    }
  );
}
